<template>
  <div class="invite-code-box">
    <span class="typo-body-m-bold">내 초대 코드</span>
    <div class="invite-code-box__code">
      <span class="typo-body-l-bold">{{ code || '알수없음' }}</span>
    </div>
    <div class="invite-code-box__buttons">
      <div class="invite-code-box__btn invite-code-box__btn--kakao" @click="$emit('kakao-click')">
        <img src="@/assets/home/icn_logo_kakao.png" class="invite-code-box__btn-icon" />
      </div>
      <div class="invite-code-box__btn invite-code-box__btn--link" @click="$emit('link-click')">
        <img src="@/assets/home/icn_link_default.png" class="invite-code-box__btn-icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteCodeBox',
  props: {
    code: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.invite-code-box {
  display: flex;
  width: 100%;
  padding: 32px 16px 72px 16px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  box-sizing: border-box;
}

.invite-code-box > .typo-body-m-bold {
  align-self: flex-start;
  margin-bottom: -24px;
}

.invite-code-box__code {
  display: flex;
  height: 105px;
  padding: 40px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--color-divider-200, #E5E8EB);
  background: #FFF;
  box-sizing: border-box;
}

.invite-code-box__code .typo-body-l-bold {
  color: var(--color-text-main, #191F28);
  text-align: center;
}

.invite-code-box__buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.invite-code-box__btn {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.invite-code-box__btn--kakao {
  background: #FEE500;
}

.invite-code-box__btn--link {
  background: #E5E8EB;
}

.invite-code-box__btn-icon {
  width: 24px;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/InviteCodeBox.vue